module.exports = __webpack_public_path__ + "img/01_Participation_Certificate.32482e02.png";